import { Client } from '../../../store/clients/reducer'

export default function (client: Client): string | null {
  return client.CIOMagicLink ?? null
}
